export default __webpack_public_path__ + "static/media/2016 GENERAL INFORMATION SHEET (GIS).ed132cb0.pdf";